import { useSelector } from 'react-redux';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue } from 'content-management-data-lib';
import { useContentDetailsDataProvider } from 'content-management-details-lib/providers/ContentDetailsDataProvider';
import { makeAsyncComponent } from 'page-lib/utils/makeAsyncUtils';
import useRouteParams from '../hooks/useRouteParams';
import { getUserHasGoogleSearchConsoleAccess, selectAuthState } from '../selectors';
import useContentId from '../hooks/useContentId';
import { useTrackPageView } from '../hooks/useTrackPageView';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AsyncInternalLinksContainer = makeAsyncComponent(() => import( /* webpackChunkName: "InternalLinksContainer" */'content-intel-content-details-optimize-panel/components/internalLinks/InternalLinks'));
const AsyncKeywordContainer = makeAsyncComponent(() => import( /* webpackChunkName: "KeywordSection" */'content-intel-content-details-optimize-panel/components/searchQueries/SearchQueries'));
const AsyncOptimizationContentPanel = makeAsyncComponent(() => import( /* webpackChunkName: "OptimizationContentPanel" */'content-intel-content-details-optimize-panel/components/OptimizePanel'));
const OptimizationContainer = () => {
  const {
    path
  } = useRouteMatch();
  const {
    contentObject
  } = useContentDetailsDataProvider();
  const contentId = useContentId();
  const {
    pageTypeSlug
  } = useRouteParams();
  const auth = useSelector(selectAuthState);
  const userHasGoogleSearchConsoleAccess = useSelector(getUserHasGoogleSearchConsoleAccess);
  const pageUrl = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.ABSOLUTE_URL);
  useTrackPageView('optimization');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        render: () => /*#__PURE__*/_jsx(AsyncOptimizationContentPanel, {
          auth: auth,
          contentId: contentId,
          contentType: pageTypeSlug,
          renderNavMarker: () => /*#__PURE__*/_jsx(NavMarker, {
            name: "OPTIMIZATION_PANEL_LOADED"
          })
        }),
        path: `${path}/seo`
      }), userHasGoogleSearchConsoleAccess && /*#__PURE__*/_jsx(Route, {
        render: () => /*#__PURE__*/_jsx(AsyncKeywordContainer, {
          renderNavMarker: () => /*#__PURE__*/_jsx(NavMarker, {
            name: "OPTIMIZATION_KEYWORD_LOADED"
          }),
          url: pageUrl
        }),
        path: `${path}/queries`
      }), /*#__PURE__*/_jsx(Route, {
        render: () => /*#__PURE__*/_jsx(AsyncInternalLinksContainer, {
          auth: auth,
          renderNavMarker: () => /*#__PURE__*/_jsx(NavMarker, {
            name: "OPTIMIZATION_INTERNAL_LINKS_LOADED"
          }),
          url: pageUrl
        }),
        path: `${path}/internalLinks`
      }), /*#__PURE__*/_jsx(Redirect, {
        to: `${path}/seo`
      })]
    }), /*#__PURE__*/_jsx(NavMarker, {
      name: "OPTIMIZATION_TAB_LOADED"
    })]
  });
};
export default OptimizationContainer;